import { apiSlice } from "@/redux/rtk/features/apiSlice/apiSlice";

export const dealStageApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDealStages: builder.query({
      query: () => ({
        url: `deal-stage?query=all`,
      }),
      providesTags: ["DealStage"],
    }),
  }),
});

export const { useGetDealStagesQuery } = dealStageApi;

